'use client';

import { Suspense } from 'react';
import { SignupEntryScreen, takePersonifyReturn } from '@/features/signup';

// Personify's OAuth return values leave the address bar when this route's
// module loads, before the root layout's analytics init can read the URL.
takePersonifyReturn();

export default function SignupPage() {
  // The flow reads its legacy params from the query string; on a static
  // export that read must sit under a Suspense boundary.
  return (
    <Suspense fallback={null}>
      <SignupEntryScreen />
    </Suspense>
  );
}
